import React, { ReactNode, FC, useCallback, MouseEvent } from 'react';
import useTranslation from 'ia-react-core/~/hooks/useTranslation';
import PageErrorMessage, { PageErrorMessageProps } from '../PageErrorMessage';

export interface TechnicalErrorPageMessageProps extends PageErrorMessageProps {
  /** The content to display when there is no error */
  children?: ReactNode;
  /** Custom error message */
  message?: ReactNode;
  /** The title of the error */
  errorTitle?: ReactNode;
  /** Text of the retry button. If not defined, no error button will display */
  buttonText?: ReactNode;
  /** Callback of the retry button */
  onButtonClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const TechnicalErrorPageMessageDefaultProps = {};

const TechnicalErrorPageMessage: FC<TechnicalErrorPageMessageProps> = ({
  errorTitle, children, message, buttonText, onButtonClick, ...props
}) => {
  const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    if (onButtonClick) onButtonClick(event);
  }, [onButtonClick]);

  const { t } = useTranslation('Core.TechnicalErrorPageMessage');

  return (
    <PageErrorMessage
      onButtonClick={handleClick}
      errorTitle={errorTitle || t('title')}
      message={message || t('message')}
      buttonText={buttonText || t('technicalErrorButton')}
      {...props}
    />
  );
};

TechnicalErrorPageMessage.defaultProps = TechnicalErrorPageMessageDefaultProps;

export default TechnicalErrorPageMessage;
